import React, { useEffect, useState } from 'react';
import { Empty, Form, message, Select, Tabs, TreeSelect } from '@drip/drip-design';
import IconTip from '@/components/icon-tip';
import _ from 'lodash';
import { filterConditions } from '@/common/utils';
import apis from '@/pages/mvp-panel/participant-data/apis';
import ChannelTab from '@/pages/mvp-panel/participant-data/components/channel-tab';
import ParticipatingChannel
  from '@/pages/mvp-panel/participant-data/components/channel-tab/components/participating-channel';
import RealTimeData from '@/pages/mvp-panel/participant-data/components/channel-tab/components/real-time-data';
import ChannelEffectTrend
  from '@/pages/mvp-panel/participant-data/components/channel-tab/components/channel-effect-trend';
import SecKill from '@/pages/mvp-panel/participant-data/components/channel-tab/components/sec-kill';
import CommonNoAccess from '@/pages/mvp-panel/participant-data/components/no-access';
const userTypeObj = {
  'placeErp': {
    "ord": "4",
    "value": "销售ERP",
    "key": "placeErp"
  },
  'dept':   {
    "ord": "1",
    "value": "运营部门",
    "key": "dept"
  },
  'erp': {
    "ord": "2",
    "value": "运营ERP",
    "key": "erp"
  },
  'placeDept': {
    "ord": "3",
    "value": "销售部门",
    "key": "placeDept"
  }
}
const userType = ['dept', 'erp']
function formatUserType(type){
  const typeList = type.map(item=>(item.key))
  const newTypeList = _.intersection(userType,typeList);
  return newTypeList.map(item=>(userTypeObj[item]))
}
function findFirstAvailableCode(arr) {
  if (!arr || !arr.length) return [];
  let fullCode = '';
  function findCode(list) {
    let code = '';
    code = list.find((item) => !item.disabled);
    if (!code && list[0].children && list[0].children.length) {
      findCode(list[0].children);
    } else {
      fullCode = code.deptFullCode;
    }
  }
  findCode(arr);
  return fullCode;
}

export default function (props) {

  const [form] = Form.useForm();
  const [dataScopeFilter, setDataScopeFilter] = useState();
  const [filter, setFilter] = useState();
  const [originFilter, setOriginFilter] = useState();
  const [userType, setUserType] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [noAccess, setNoAccess] = useState(false);

  const [inSecKill, setSecKill] = useState(null);


  function getFilterValue(value) {
    let formValues = {};
    if (value.userType == 'dept' || value.userType == 'placeDept') {
      const { dept } = value;
      const _dept = dept.split('/');
      let buId = _dept[0],
        deptId1 = _dept[1] || '全部',
        deptId2 = _dept[2] || '全部',
        deptId3 = _dept[3] || '全部',
        deptId4 = _dept[4] || '全部',
        participant = '全部';
      formValues = { userType: value.userType, buId, deptId1, deptId2, deptId3, deptId4, participant };
    }
    if (value.userType == 'erp' || value.userType == 'placeErp') {
      formValues = { userType: value.userType, participant: value.erp };
    }
    return filterConditions(formValues);
  }

  function onChangeOriginFilter(val){
    // console.log('onChangeOriginFilter-----------', val)
    const { userType } = filter;
    const value = {
      userType: userType,
      dept:val.dept,
      erp: val.erp,
    };
    form.setFieldsValue(value);
    setOriginFilter(value)
    setFilter(getFilterValue(value));
    setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
  }

  useEffect(() => {
    apis
      .queryGeneralDataScopeByErp()
      .then((res) => {
        setLoaded(true);
        const { ret, data } = res;
        if (ret === '0' && data && data.userType) {
          if(data.userType?.length > 0){
            data.userType = formatUserType(data.userType)
            setNoAccess(false)
          } else{
            setNoAccess(true)
          }
          setDataScopeFilter(data);
        } else {
          throw '暂无数据';
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, []);

  //初始值;
  useEffect(() => {
    if (!dataScopeFilter?.userType?.length) return;
    const { userType, dataScope } = dataScopeFilter;
    const _userType = userType[0]?.key;
    const value = {
      userType: _userType,
      dept:
        (_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]
          ? findFirstAvailableCode(dataScope[_userType])
          : [],
      erp: (_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType] ? dataScope[_userType][0] : [],
    };

    form.setFieldsValue(value);
    setOriginFilter(value)
    setFilter(getFilterValue(value));
    setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
  }, [dataScopeFilter, form]);

  const onFormChange = (changeValue, allValue) => {

    if (changeValue.userType) {
      const _userType = changeValue.userType;
      const { dataScope } = dataScopeFilter;
      const value = {
        userType: _userType,
      };
      if ((_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]) {
        value.dept = findFirstAvailableCode(dataScope[_userType]);
      } else if ((_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType]) {
        value.erp = dataScope[_userType][0];
      }
      form.setFieldsValue(value);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    } else {
      const value = form.getFieldsValue(true);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    }
  };
  function NoAccess() {
    return (
      <div style={{padding: '20px 25px'}}>
        <CommonNoAccess/>
      </div>

      // <Empty
      //   style={{ paddingTop: 250, paddingBottom: 250 }}
      //   description="名下有品的erp或部门Leader自动获取秒杀看数权限，品类营销角色需要申请部门权限
      //   https://joyspace.jd.com/pages/ldroyXUSUXH8wnE1f6Uc
      //   如有疑问请进咚咚群咨询:10202084337"
      // />
    );
  }

  return !dataScopeFilter?.userType?.length ? (
    <NoAccess />
  ) : (
    <div>
      <div className="participant-data-card-bg-new">
        <div className="participant-data-con">
          <Form form={form} layout="inline" onValuesChange={onFormChange}>
            <Form.Item
              name="userType"
              label={
                <span>
                数据范围
                <IconTip title="选择您有权限的角色及数据范围。运营部门/ERP代表采销控分离前的部门/采销，销售部门/ERP代表采销控分离后的部门/销售。如有疑问请进咚咚群咨询:10202084337。" />
              </span>
              }
              initialValue={dataScopeFilter.userType[0].key}
            >
              <Select style={{ width: 200 }} disabled={!!inSecKill}>
                {dataScopeFilter?.userType?.map((item) => (
                  <Select.Option value={item.key} key={item.key}>
                    {item.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prevValue, curValue) => prevValue.userType !== curValue.level}>
              {({ getFieldValue }) => {
                const userType = getFieldValue('userType');
                if (userType == 'dept' || userType == 'placeDept') {
                  return (
                    <Form.Item
                      name="dept"
                    >
                      <TreeSelect
                        disabled={!!inSecKill}
                        style={{ width: 300 }}
                        changeOnSelect
                        allowClear={false}
                        fieldNames={{ label: 'name', value: 'deptFullCode', children: 'children' }}
                        treeData={dataScopeFilter.dataScope[userType]}
                        treeNodeLabelProp="deptFullName"
                      />
                    </Form.Item>
                  );
                }
                if (userType == 'placeErp' || userType == 'erp') {
                  return (
                    <Form.Item
                      name="erp"
                    >
                      <Select
                        disabled={!!inSecKill}
                        style={{ width: 200 }}
                        showSearch
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {dataScopeFilter.dataScope[userType]?.map((item) => (
                          <Select.Option value={item} key={item}>
                            {item}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  );
                }
              }}
            </Form.Item>
          </Form>
        </div>
      </div>
      {/*<ChannelTab filter={filter} />*/}
      <div>
        {!inSecKill ? (
          <>
            <ParticipatingChannel filter={filter} setSecKill={setSecKill} />
            <RealTimeData filter={filter} />
            <ChannelEffectTrend filter={filter} setSecKill={setSecKill} />
          </>
        ) : (
          <SecKill
            filter={{
              ...filter,
              ...inSecKill,
            }}
            setSecKill={setSecKill}
          ></SecKill>
        )}
      </div>
    </div>
  );
}
